/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineListRequest {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineListRequest.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineListRequest>): AIUnitEconomicsBaselineListRequest {
        let obj = Object.assign(new AIUnitEconomicsBaselineListRequest(), model);
        AIUnitEconomicsBaselineListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineListRequest>): AIUnitEconomicsBaselineListRequest {
        if (!model) return null;
        return AIUnitEconomicsBaselineListRequest.newInstance(<AIUnitEconomicsBaselineListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineListRequest) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineListRequest): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AIUnitEconomicsBaselineFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AIUnitEconomicsBaselineSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AIUnitEconomicsBaselineSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AIUnitEconomicsBaselineFilter;

}
